<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Sponsorship Levels">
                    <div>
                        <AmountSelectorList
                          :customLabel="tikvaLabel"
                          @update:emittedDescription="handleUpdate"
                        />
                        <ErrorLabel field="amount" />
                    </div>
                </FormSection>
                <FormSection title="Ways To Give">
                	<div class="frequency">
                    <PaymentOptions addSplit addMonthly monthesSelector/>
                  </div>
                </FormSection>

                <FormSection title="Your Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
                    <FormRow>
                      <NewsletterSubscribe text="Sign me up for the Newsletter" />
                    </FormRow>   										
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm()

    const tikvaLabel = 'Romania - Tikva Orphanage Program'

    // Only Tikva gifts get tagged; sponsorship tiers keep description empty
    const handleUpdate = (value: string | null) => {
      setValue('description', value === tikvaLabel ? tikvaLabel : null)
    }

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    if (props.campaign) {
      setValue('applications.0.campaign', props.campaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    return {
      form,
      submit,
      tikvaLabel,
      handleUpdate,
    }
  },
})
</script>
<style scoped lang="scss">

h2{
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.ou-donation-form ::v-deep h2 {
	font-size: 20px;
    text-transform: none;
    letter-spacing: normal;
}
label.newsletter__label{
	    padding-left: 7px;
}
</style>

